import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-jury',
    templateUrl: './jury.component.html',
    styleUrls: ['./jury.component.scss']
})
export class JuryComponent implements OnInit {
    juryList: any = []
    selectedJury: any;
    selectedIndex: any = 0;
    isSideBarOpen: boolean = false
    version: any = [];
    allVersions: any = [];
    isArchive:boolean=false;

    constructor(public awardService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        }
        this.awardService.getAllCurrentJury().subscribe((res: any) => {
            this.juryList = res;
            this.selectedJury = this.juryList.cinejoyJudges[0];
        }, err => {

        })
        this.getAllVersion()
    }

    onClickOfItem(event: any, index: any) {
        this.selectedJury = event;
        this.selectedIndex = index;
    }

    onToggleSideNav() {
        this.isSideBarOpen = !this.isSideBarOpen;
    }

    getAllVersion() {
        this.awardService.getAllAwardsVersion().subscribe(data => {
            //Checking if current page is Archive, don't show Current version else show Current version.
            if (this.isArchive) {
                const archiveVersions = data.awardsVersions.filter(v => v.isCurrent === 0);
                this.allVersions = archiveVersions;
                const maxVersion = archiveVersions.reduce((prev, current) =>
                    Number(prev.awardsVersion) > Number(current.awardsVersion) ? prev : current
                ); //Setting the version to the biggest number
                //Checking for any pre-set data
                if(this.awardService.getVersion()) this.version = this.awardService.getVersion().id;
                else this.version = maxVersion?.id;
                this.onChangeVersion(this.version);
              } else {
                this.allVersions = data.awardsVersions;
                const currentVersion = this.allVersions.find(v => v.isCurrent === 1);
                this.version = currentVersion?.id;
              }
        }, err => {

        })
    }

    onChangeVersion(event: any) {
        let version = this.allVersions.find((v: any) => (parseInt(v.id) === parseInt(this.version)))
        this.awardService.setVersion(version);
        this.awardService.getArchivedJuryByVersion(version.awardsVersion).subscribe(data => {
            this.juryList = data;
            this.selectedJury = this.juryList?.cinejoyJudges[0];
            this.selectedIndex = 0;
        }, err => {
            alert("Error while fetching data")
        })
    }

    navigateBack(){
        if(this.isArchive){
            this.router.navigateByUrl('/cinejoy/archive/awards')
        }else{
            this.router.navigateByUrl('/cinejoy/awards')
        }
    }


}